import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import * as styles from './Tooltip.scss';

var Tooltip = /*#__PURE__*/function (_Component) {
  _inherits(Tooltip, _Component);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    _classCallCheck(this, Tooltip);

    return _super.apply(this, arguments);
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("span", {
        style: this.props.style
      }, /*#__PURE__*/React.createElement("span", {
        "data-tip": true,
        "data-for": this.props.name,
        className: styles.iconWrap
      }, this.props.showHelpIcon && /*#__PURE__*/React.createElement("i", {
        className: "icon ion-help-circled ".concat(styles.helpIcon)
      }), this.props.children), /*#__PURE__*/React.createElement(ReactTooltip, {
        id: this.props.name,
        multiline: true
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          textTransform: 'none'
        }
      }, this.props.message)));
    }
  }]);

  return Tooltip;
}(Component);

_defineProperty(Tooltip, "defaultProps", {
  showHelpIcon: true,
  name: 'default',
  style: {}
});

export { Tooltip as default };